export default __webpack_public_path__ + "static/media/uparrow.b68cb0e3.svg";